import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';

function CommissionsSalesGraphFilters(props) {
  const { t, activeFilter, onFilterChange } = props;

  return (
    <div className="commissions-sales-graph-filters">
      {['day', 'week', 'month', 'year'].map(filter => (
        <button
          key={filter}
          type="button"
          className={`btn m-btn m-btn--pill ${
            activeFilter === filter ? 'btn-dynamic' : 'btn-outline-secondary'
          }`}
          onClick={() => onFilterChange(filter)}
        >
          {t(`chartPortlet.${filter}`)}
        </button>
      ))}
    </div>
  );
}

CommissionsSalesGraphFilters.propTypes = {
  t: PropTypes.func.isRequired,
  activeFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

export default translate(CommissionsSalesGraphFilters);
